





















































import { Component, Vue } from 'vue-property-decorator';
import { IProxyErrorUpdate, ProxyErrorTypes } from '@/interfaces';
import {
  dispatchGetServices,
  dispatchGetProxyError,
  dispatchUpdateProxyError,
  readOneProxyError,
  readServices,
} from '@/store/admin/accessors';
import VTextFieldWithValidation from '@/components/VTextFieldWithValidation.vue';
import VSelectWithValidation from '@/components/VSelectWithValidation.vue';
import { ValidationProvider } from 'vee-validate';

@Component({
  components: {
    VTextFieldWithValidation,
    VSelectWithValidation,
  },
})
export default class EditProxyError extends Vue {
  public valid = false;
  public statusCode: number | null = null;
  public errorCode: number = 0;
  public type: ProxyErrorTypes | null = null;
  public conn: string | null = null;
  public serviceName: string = '';
  public errorDescription: string = '';
  public userBanDuration: number = 0;

  public types = Object.values(ProxyErrorTypes);

  public servicesList = [];
  public services;

  public $refs!: {
    observer: InstanceType<typeof ValidationProvider>;
  };

  public async mounted() {
    await dispatchGetProxyError(this.$store, Number(this.$router.currentRoute.params.id));
    await dispatchGetServices(this.$store);
    this.services = new Map<string, number>(
      readServices(this.$store).map((item) => [item.name, item.id] as [string, number]),
    );
    this.servicesList = Array.from(this.services.keys());
    this.reset();
  }

  public reset() {
    this.$refs.observer.reset();
    if (this.proxyError) {
      this.statusCode = this.proxyError.status_code;
      this.errorCode = this.proxyError.error_code;
      this.type = this.proxyError.type;
      this.conn = this.proxyError.conn;
      this.serviceName = this.proxyError.service_name;
      this.errorDescription = this.proxyError.error_description;
      this.userBanDuration = this.proxyError.user_ban_duration;
    }
  }

  public cancel() {
    this.$router.back();
  }

  public async submit() {
    if (await this.$refs.observer.validate()) {
      const updatedProxyError: IProxyErrorUpdate = {
        status_code: this.statusCode || null,
        error_code: this.errorCode,
        type: this.type,
        conn: this.conn,
        error_description: this.errorDescription,
        user_ban_duration: this.userBanDuration,
        service_id: this.services.get(this.serviceName),
      };
      const result = await dispatchUpdateProxyError(this.$store, {
        id: this.proxyError!.id,
        proxyError: updatedProxyError,
      });
      if (result) {
        this.$router.push('/main/admin/proxy_errors');
      }
    }
  }

  get proxyError() {
    return readOneProxyError(this.$store)(+this.$router.currentRoute.params.id);
  }
}
